import { uiComponents, uiStates } from '@/tools/viewState';
import { generateUUID } from '@/tools/helpers';

import { actionTypes, mutationTypes, exhibitionTypes } from '@/types';
import { SEARCH_SCOPES } from '@/tools/consts';
/**
 * This action open the ui--search with scope Glossary,
 * it shows all Glossary terms in alphabetical order grouped
 * by letters seperators
 *
 * @param {*} store
 */
export default function ({ state, rootState, commit, dispatch }, { options } = {}) {
	const data = rootState.glossary
		.map((entry) => ({
			key: generateUUID(),
			title: entry.term,
			id: entry.id,
			class: 'data--' + entry.id,
			tag: entry.keywords.concat([entry.term]).join(','),
			url: '',
			role: 'link',
			click: () => {
				commit(mutationTypes.viewStateSetUiState, {
					id: uiComponents.uiSearchGlossary,
					uiState: uiStates.hidden,
				});
				dispatch(actionTypes.pushUrl, {
					url: `/${exhibitionTypes.glossary}/${entry.id}`,
					replace: false,
				});
			},
		}))
		.sort((a, b) =>
			// FIXME this is bad code
			/* eslint-disable no-nested-ternary */
			a.title.toUpperCase() > b.title.toUpperCase()
				? 1
				: a.title.toUpperCase() < b.title.toUpperCase()
				? -1
				: 0
		);

	const alterationFunctions = [
		function (array) {
			return state.scopes.areabeacons.query // Dont add seperators if search has value
				? array
				: array.reduce(
						(acc, entry) => {
							const letter = entry.title.charAt(0).toUpperCase();
							if (letter !== acc.seperator) {
								// add new alpabetic Seperator
								acc.seperator = letter;
								acc.result.push({
									isSeperator: true,
									name: `${letter}`,
									class: `separator--${letter}`,
									iconName: 'separator',
									title: letter,
								});
							}
							acc.result.push(entry);
							return acc;
						},
						{ seperator: null, result: [] }
				  ).result;
		},
	];
	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.glossary,
		data,
		searchOptions: {
			keys: ['title', 'description', 'tag'],
			threshold: 0.3,
			caseSensitive: false,
		},
		alterationFunctions,
		options,
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchGlossary,
		uiState: uiStates.maximised,
	});
}
